export const PC_CLASS_PREFIX = 'cbd-web-base-form';

export const MOBILE_CLASS_PREFIX = 'cbd-mobile-base-form';
